import { useEffect, useMemo, useState } from "react";
import { toast } from "sonner";
import { ChevronDown, ArrowRightLeft } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { HandoverDialog } from "./HandoverDialog";

const slugOf = (n) => n.replace(/\W+/g, "-").toLowerCase();

const Row = ({ x, canEdit, onToggle, onHandover }) => (
  <div className={`flex items-center gap-2 border px-2 py-1.5 text-xs min-w-0 ${x.in_team ? "" : "opacity-60"}`} data-testid={`sales-team-row-${slugOf(x.name)}`}>
    <input type="checkbox" disabled={!canEdit || !x.login} checked={x.in_team} onChange={() => onToggle(x)} data-testid={`sales-team-check-${slugOf(x.name)}`} aria-label={`${x.name} in sales team`} />
    <span className="font-medium truncate" title={x.email || ""}>{x.name}</span>
    <span className="text-muted-foreground ml-auto text-right shrink-0">{x.leads} leads · {x.uids} UIDs{x.login ? ` · login: ${x.login}` : " · no login"}</span>
    {canEdit && <button data-testid={`sales-team-handover-${slugOf(x.name)}`} title={`Hand over ${x.name}'s open records`} onClick={() => onHandover(x.name)}
      className="border h-7 w-7 flex items-center justify-center hover:border-primary shrink-0"><ArrowRightLeft className="h-3.5 w-3.5" /></button>}
  </div>
);

export const SalesTeamPanel = () => {
  const [d, setD] = useState(null);
  const [open, setOpen] = useState(false);
  const [hand, setHand] = useState(null);
  const load = () => api.get("/admin/sales-team").then((r) => setD(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const team = useMemo(() => (d ? d.items.filter((x) => x.in_team).map((x) => x.name) : []), [d]);
  if (!d) return null;
  const toggle = (x) => api.put("/admin/sales-team", { name: x.name, in_team: !x.in_team }).then((r) => { toast.success(r.data.message); load(); }).catch((e) => toast.error(errMsg(e)));
  return (
    <div className="ax-panel p-3 mb-4" data-testid="sales-team-panel">
      <button data-testid="sales-team-toggle" onClick={() => setOpen(!open)} className="flex items-center justify-between w-full text-left">
        <span className="ax-label">Sales team · account owners ({team.length} of {d.items.length})</span>
        <ChevronDown className={`h-4 w-4 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <>
        <p className="text-xs text-muted-foreground my-2">Everyone with an active login whose role can add or edit leads or UIDs, plus every name already on a lead or UID. Only ticked logins can be picked as an owner.
          Names with no login stay on their old leads and UIDs and appear in the owner filters as "(former)".{d.can_edit ? " Use the arrows button to hand over someone's open leads and UIDs." : " Only founders can change this."}</p>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-1.5">{d.items.map((x) => <Row key={x.name} x={x} canEdit={d.can_edit} onToggle={toggle} onHandover={setHand} />)}</div>
      </>}
      {hand && <HandoverDialog name={hand} team={team} onClose={() => setHand(null)} onDone={() => { setHand(null); load(); }} />}
    </div>
  );
};
